import { memo } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { appointmentDraftSelectors, bookingsSelectors } from '~/api';

import { Section } from '~/components/review-details/section';
import { ProductsList } from '../products-list';

import { PATH_NAMES } from '../../constants';

export const YourProducts = memo(
  ({ sectionTitle = '', history, showEditButton = true, products }) => (
    <Section
      history={history}
      editPath={PATH_NAMES.SELECT_PRODUCTS}
      analyticsSectionType="products"
      category={sectionTitle || 'Your Products'}
      isNotDescriptionListContent
      showEditButton={showEditButton}
    >
      <ProductsList products={products} hasProductControls={false} />
    </Section>
  ),
);

YourProducts.displayName = 'YourProducts';

export const mapStateToProps = (state) => {
  const draftProducts = appointmentDraftSelectors.selectProducts(state);
  return {
    products: draftProducts.length >= 1 ? draftProducts : bookingsSelectors.selectProducts(state),
  };
};

export const ConnectedYourProducts = withRouter(connect(mapStateToProps)(YourProducts));

YourProducts.propTypes = {
  sectionTitle: PropTypes.string,
  history: PropTypes.shape({}).isRequired,
  showEditButton: PropTypes.bool,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
